<template>
    <div class="row-component">
        <template v-for="(component, index) in components || []">
            <component
                :is="getComponentName(component.name)"
                :config="Object.keys(component.config || {}).length > 0 ? component.config : {}"
                :emitEvents="getEmitEvents(component)"
                :state="state"
                :eventBus="eventBus"
                :index="index"
                :column="column"
                :routeName="routeName"
                :row="row"
                :rowIndex="rowIndex"
                :embeddedModules="getEmbeddedModules(component)"
                :columnIndex="columnIndex"
                :eventSourceService="eventSourceService"
                :eventManager="eventManager"
                :parentState="parentState"
                :parent="parent"
            ></component>
        </template>
    </div>
</template>

<script>

export default
{
    components: {},
    props: {
        column: {
            Type: Object,
        },
        state: {
            type: Object
        },
        components: {
            type: Array
        },
        eventBus: {
            Type: Object,
        },
        routeName: {
            type: String
        },
        row: {
            type: Object,
        },
        rowIndex: {
            type: Number
        },
        embeddedModules: {
            type: Array
        },
        columnIndex: {
            type: Number
        },
        eventSourceService: {
            type: Object
        },
        eventManager: {
            type: Object
        },
        parentState: {
            type: Object
        },
        parent: {
            type: Object,
        },
    },
    data() {
        return {
        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        getComponentName(componentName) {
            return require(`./${componentName}.vue`);
        },
        getEmbeddedModules(component) {
            return component.embeddedModules || this.embeddedModules;
        },
        getEmitEvents(component) {
            let emitEvents = {};

            Object.entries(component.emitEvents || {}).forEach(entry => {
                let [eventName, value] = entry;

                emitEvents[eventName] = [];

                (value || []).forEach(e => {
                    emitEvents[eventName].push(Object.assign({}, e));
                });
            });

            return emitEvents;
        }
    }
}
</script>

<style scoped>
    .row-component > div {
        float: left;
    }
 </style>



// WEBPACK FOOTER //
// GridComponentFactory.vue?7a7344e8